import React from "react";
import { useTranslation } from 'react-i18next';

const NodesPagination = ({
  currentPage,
  nodesPerPage,
  totalNodes,
  paginate,
}) => {
  const { t } = useTranslation();
  const totalPages = Math.ceil(totalNodes / nodesPerPage);

  if (totalPages <= 1) return null;

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        {t('nodesPagination.showing', { 
          start: (currentPage - 1) * nodesPerPage + 1,
          end: Math.min(currentPage * nodesPerPage, totalNodes),
          total: totalNodes
        })}
      </div>
      <div className="pagination-controls">
        <button
          className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
          onClick={() => currentPage > 1 && paginate(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ◀ {t('nodesPagination.previous')}
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => paginate(i + 1)}
            className={`pagination-number ${currentPage === i + 1 ? "active" : ""}`}
          >
            {i + 1}
          </button>
        )).slice(
          Math.max(0, currentPage - 3),
          Math.min(totalPages, currentPage + 2)
        )}
        <button
          className={`pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
          onClick={() => currentPage < totalPages && paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          {t('nodesPagination.next')} ▶
        </button>
      </div>
    </div>
  );
};

export default NodesPagination;